import React, { useState, useContext, useEffect, useMemo, useReducer } from 'react';
import { externalComponent } from '../AppRoutes';
import { Box } from '@mui/material';
import { api } from '../../services/api';
import Table, { TableHook } from '../Table';
import { lockedReducer } from '../Utils/reducers';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const url = '/eventos/'
let interval = 0

const formatDate = (isoDate) => {
    const date = new Date(isoDate);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

const entradaSaidaParser = (value) => {
    if (value) {
        return 'Entrada'
    } else {
        return 'Saída'
    }
}

const getEventos = async (setState, setLoader, load) => {

    if (load) {
        setLoader(true)
    }
    const res = await api.get(`${url}?limit=1000&offset=0`)
    if (res.status === 200) {
        setState({ rows: res.data.results })
    }
    if (load) {
        setLoader(false)
    }
}

const columns = (setState) => {
    return [
        { field: 'ticket_cartao', headerName: 'Ticket / Cartão', flex: 1, filterType: 'string' },
        { field: 'nome', headerName: 'Descrição', flex: 2, filterType: 'string' },
        {
            field: 'chuveiro', headerName: 'Chuveiro', flex: 1,
            filterType: 'choices', choices: { '1': 'Sim', '0': 'Não' },
            renderCell: ({ value }) => (
                <>
                    {value ?
                        <CheckCircleIcon sx={{ color: 'green' }} />
                        :
                        <HighlightOffIcon sx={{ color: 'red' }} />
                    }
                </>
            )
        },
        {
            field: 'entrada_saida', headerName: 'Entrada / Saída', flex: 1,
            filterType: 'choices', choices: { '1': 'Entrada', '0': 'Saída' },
            renderCell: ({ value }) => (
                entradaSaidaParser(value)
            )
        },
        {
            field: 'created_at', headerName: 'Data / Hora', flex: 1, filterType: 'daterange',
            renderCell: ({ value }) => (
                formatDate(value)
            )
        },
    ]
}

const Eventos = () => {

    const { setLoader } = useContext(externalComponent)

    const [table, reloadTable] = TableHook()

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        deleteRow: null,
    })

    useEffect(() => {
        getEventos(setState, setLoader, true)
        interval = setInterval(() => {
            getEventos(setState, setLoader, false)
        }, 5000)

        return () => {
            clearInterval(interval)
        }
    }, [setLoader])

    return (
        <>
            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.rows}
                        columns={useMemo(() => columns(setState))}
                        pagination
                        density='compact'
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true
                        }}
                        getURL={url}
                        updateRows={(rows) => setState({ 'rows': rows })}
                        innerRef={table}
                    />
                </Box>
            </Box>
        </>
    )
}

export default Eventos;